module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2669/plan1-1-601b200394a2c4587c337a584bc9fde0.webp";